import { SET_LOCALE } from '../constants';

const initialState = 'en-US';

export default function setLocaleInfo(state = initialState, action) {
  switch (action.type) {
    case SET_LOCALE:
      return action.payload;
    default:
      return state;
  }
}
